<script lang="ts">
import { h, defineComponent, type VNode } from 'vue';

import { getBuildingSizeLabel } from '@/bundles/MeasurementUnits/helpers/format/getBuildingSizeFormatted';

export default defineComponent({
  name: 'BuildingSizeLabel',

  props: {
    value: {
      type: [String, Number],
      default: 0
    }
  },

  render (): VNode {
    const value = this.$props.value;
    const className = `${this.$attrs.class || ''}`.trim();

    const label = getBuildingSizeLabel(value);

    if (!label) {
      return h('span', { class: `${className} na`.trim() }, 'N/A');
    }

    return h('span', { ...this.$attrs, class: className || undefined }, label);
  }
});
</script>
